import { render, staticRenderFns } from "./UserNew.vue?vue&type=template&id=2c05dbea&"
import script from "./UserNew.vue?vue&type=script&lang=js&"
export * from "./UserNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\www\\aliventa\\gruene-hex\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c05dbea')) {
      api.createRecord('2c05dbea', component.options)
    } else {
      api.reload('2c05dbea', component.options)
    }
    module.hot.accept("./UserNew.vue?vue&type=template&id=2c05dbea&", function () {
      api.rerender('2c05dbea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserNew.vue"
export default component.exports